import GraphqlError from './GraphqlError';

export default class DiscountCodeNotFoundError extends GraphqlError {
  
  /** @type {string} */
  #dicountCode;

  /**
   * @param {string} message 
   * @param {string} query 
   * @param {string} discountCode 
   * @param {{
   *   variables?: Map<string, any>;
   * }} kwargs 
   */
  constructor(message, query, discountCode, kwargs) {
    super(message, query, kwargs);

    this.#dicountCode = discountCode;
  }

  /**
   * Gets the discount code used that caused this error
   */
  get discountCode() {
    return this.#dicountCode;
  }
}